import dayjs, { Dayjs } from 'dayjs';
import { RadioInput } from '~/ui';
import { useTranslation } from 'react-i18next';
import { CustomDatePicker } from '~/components/Shared/CustomDatePicker/CustomDatePicker';
import CustomQuerySelect from '~/components/Shared/CustomQuerySelect/CustomQuerySelect';
import { useDebounce } from '@uidotdev/usehooks';
import styles from './RequestsReportExtra.module.scss';

interface IAccommodation {
  id: number;
  name: string;
}

interface RequestsReportExtraProps {
  reportType: string;
  onReportTypeChange: (type: string) => void;
  startDate: Dayjs | null;
  endDate: Dayjs | null;
  onStartDateChange: (date: Dayjs | null) => void;
  onEndDateChange: (date: Dayjs | null) => void;
  accommodations: IAccommodation[];
  onAccommodationsChange: (value: IAccommodation[]) => void;
  isAllAccommodationChecked: boolean;
  onAllAccommodationChange: (value: boolean) => void;
}

export const RequestsReportExtra = ({
  reportType,
  onReportTypeChange,
  startDate,
  endDate,
  onStartDateChange,
  onEndDateChange,
  accommodations,
  onAccommodationsChange,
  isAllAccommodationChecked,
  onAllAccommodationChange,
}: RequestsReportExtraProps) => {
  const { t } = useTranslation();
  const debouncedSearchTerm = useDebounce('', 500);

  const params = {
    sort: '',
    perPage: 100,
    field: '',
    query: debouncedSearchTerm,
    page: 1,
  };

  const disabledDate = (current: Dayjs) => {
    return current && current > dayjs().endOf('day');
  };

  return (
    <div>
      <div className={styles.radioWrapper}>
        <RadioInput
          label={t('brief_report')}
          name="type_report"
          value="ticket_accommodation_analytics_export"
          onChange={() =>
            onReportTypeChange('ticket_accommodation_analytics_export')
          }
          checkValue={reportType}
        />
        <RadioInput
          label={t('full_report')}
          name="type_report"
          value="ticket_analytics_accommodation_date_export"
          onChange={() =>
            onReportTypeChange('ticket_analytics_accommodation_date_export')
          }
          checkValue={reportType}
        />
      </div>

      <CustomQuerySelect
        label={t('object')}
        query="admin/accommodations"
        queryKey={['accommodations', params]}
        placeholder={t('accommodations_validate')}
        params={params}
        value={accommodations}
        onChange={(value) => {
          if (Array.isArray(value)) {
            onAccommodationsChange(value);
          }
        }}
        required
        disabled={isAllAccommodationChecked}
        multiselect
        isSearchEnabled
        hasCheckbox
        checkboxLabel={t('all_accommodation_selection')}
        setIsCheckedAll={(value) => onAllAccommodationChange(value)}
      />

      <div className={styles.dateWrapper}>
        <span className={styles.labelText}>
          {t('date')}
          <span className={styles.labelStar}>*</span>
        </span>
        <CustomDatePicker
          value={[startDate, endDate]}
          placeholder={[t('date_from'), t('date_by')]}
          disabledDate={disabledDate}
          showPresets={true}
          onChange={(name, value) => {
            if (name === 'start_date') {
              onStartDateChange(value);
            } else if (name === 'end_date') {
              onEndDateChange(value);
            }
          }}
        />
      </div>
    </div>
  );
};
